__turbopack_context__.v({
  "banner": "BlockCallout-module-scss-module__m5j4eW__banner",
  "bannerSimple": "BlockCallout-module-scss-module__m5j4eW__bannerSimple",
  "buttonComponentSlot": "BlockCallout-module-scss-module__m5j4eW__buttonComponentSlot",
  "callout": "BlockCallout-module-scss-module__m5j4eW__callout",
  "calloutWrapper": "BlockCallout-module-scss-module__m5j4eW__calloutWrapper",
  "calloutWrapperFlex": "BlockCallout-module-scss-module__m5j4eW__calloutWrapperFlex",
  "card": "BlockCallout-module-scss-module__m5j4eW__card",
  "copy": "BlockCallout-module-scss-module__m5j4eW__copy",
  "divot": "BlockCallout-module-scss-module__m5j4eW__divot",
  "eyebrow": "BlockCallout-module-scss-module__m5j4eW__eyebrow",
  "hasNotch": "BlockCallout-module-scss-module__m5j4eW__hasNotch",
  "hero": "BlockCallout-module-scss-module__m5j4eW__hero",
  "imageContainer": "BlockCallout-module-scss-module__m5j4eW__imageContainer",
  "inner": "BlockCallout-module-scss-module__m5j4eW__inner",
  "makersReserve": "BlockCallout-module-scss-module__m5j4eW__makersReserve",
  "masthead": "BlockCallout-module-scss-module__m5j4eW__masthead",
  "recommended": "BlockCallout-module-scss-module__m5j4eW__recommended",
  "roundedCorners": "BlockCallout-module-scss-module__m5j4eW__roundedCorners",
  "section": "BlockCallout-module-scss-module__m5j4eW__section",
  "simpleEyebrow": "BlockCallout-module-scss-module__m5j4eW__simpleEyebrow",
  "withCopy": "BlockCallout-module-scss-module__m5j4eW__withCopy",
});
